import { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html {
    scroll-behavior: smooth;
  }

  html,
  body,
  ___gatsby,
  ___gatsby > div {
    font-family: ${({ theme }) => theme.typography.fontFamily}, sans-serif;
    margin: 0;
    padding: 0;
    color: ${({ theme }) => theme.palette.text.primary};
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
    background: var(--Shades-0, #FFF);
    background-color: var(--Shades-0, #FFF);
    @media screen and (min-width: ${({ theme }) => theme.breakpoints.md}px) {
      font-size: 20px;
    }
  }

  a {
    display: inline-block;
    color: ${({ theme }) => theme.palette.text.link};
    letter-spacing: 0;
    font-weight: 600;
    text-decoration: none;
  }

`;
